module.exports = __webpack_public_path__ + "static/media/cscc_brunch-on-the-lawn.4908ee46.jpg";